import { secrets } from '../utils/secrets';

const WEB3FORMS_URL = 'https://api.web3forms.com/submit';
const SUBMIT_TIMEOUT_MS = 15_000;

export interface SendEmailOptions {
    name: string;
    email: string;
    phone: string;
    birthday: string;
    reason: string;
    message: string;
    hasPrescription: boolean;
    needsHomeVisit: boolean;
}

export async function sendEmail(options: SendEmailOptions): Promise<void> {
    const { name, email, phone, birthday, reason, message, hasPrescription, needsHomeVisit } = options;

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), SUBMIT_TIMEOUT_MS);

    let response: Response;
    try {
        response = await fetch(WEB3FORMS_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            signal: controller.signal,
            body: JSON.stringify({
                access_key: secrets.web3formsAccessKey,
                // botcheck is Web3Forms' honeypot — bots fill it, humans leave it empty
                botcheck: '',
                name,
                email,
                // from_name / from_email match the template variable names configured
                // in the Web3Forms dashboard for this account
                from_name: name,
                from_email: email,
                subject: reason.trim() || 'Kontaktanfrage',
                message,
                phone_number: phone || '-',
                birthday: birthday || '-',
                has_prescription: hasPrescription ? 'Ja' : '-',
                home_visit: needsHomeVisit ? 'Ja' : '-',
            }),
        });
    } finally {
        clearTimeout(timeoutId);
    }

    if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
    }

    let data: { success: boolean; message?: string };
    try {
        data = await response.json();
    } catch {
        throw new Error(`Non-JSON response (HTTP ${response.status})`);
    }

    if (!data.success) {
        throw new Error(data.message || 'Submission failed');
    }
}
